import { useQuery } from "@tanstack/react-query";
import { fetchTransactions } from "@/services/api";
import { useState } from "react";
import { toast } from "sonner";

export const useProjectTransactions = (
  projectId: string,
  initialLimit: number = 5,
) => {
  const [pagination, setPagination] = useState({
    limit: initialLimit,
    offset: 0,
    page: 1,
  });

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [
      "projectTransactions",
      projectId,
      pagination.limit,
      pagination.offset,
    ],
    queryFn: () =>
      fetchTransactions(
        pagination.limit,
        pagination.offset,
        undefined,
        undefined,
        projectId,
      ),
    enabled: !!projectId,
    meta: {
      onError: (_err: Error) => {
        toast.error("Failed to load project transactions", {
          description: "Please try again later or contact support.",
        });
      },
    },
  });

  const goToPage = (page: number) => {
    const newOffset = (page - 1) * pagination.limit;
    setPagination({
      ...pagination,
      offset: newOffset,
      page,
    });
  };

  const nextPage = () => {
    if (data && data.meta && pagination.page < data.meta.pages) {
      goToPage(pagination.page + 1);
    }
  };

  const prevPage = () => {
    if (pagination.page > 1) {
      goToPage(pagination.page - 1);
    }
  };

  return {
    transactions: data?.data || [],
    meta: data?.meta,
    isLoading,
    isError,
    error,
    pagination,
    goToPage,
    nextPage,
    prevPage,
    refetch,
  };
};
